/*
 * Copyright © Manatee. 2026 All Rights Reserved.
 * Proprietary and confidential.
 */

import type { ApiError, FieldError } from "../api/client";

/**
 * Carries a form's validation state: one banner message plus per-field
 * messages that feed each Input's `error` prop. Built either from
 * client-side checks or from the nexus failure envelope, so server-side
 * field errors paint the same way local ones do.
 */
export class ValidationError {
  readonly errorMessage: string;
  readonly fieldErrors: FieldError[];

  constructor(errorMessage: string, fieldErrors: FieldError[] = []) {
    this.errorMessage = errorMessage;
    this.fieldErrors = fieldErrors;
  }

  static fromApiError(error: ApiError): ValidationError {
    return new ValidationError(error.message, error.fieldErrors);
  }

  getFieldError(field: string): string | undefined {
    return this.fieldErrors.find((e) => e.field === field)?.message;
  }

  withoutField(field: string): ValidationError | null {
    const remaining = this.fieldErrors.filter((e) => e.field !== field);
    if (remaining.length === 0) {
      return null;
    }
    return new ValidationError(this.errorMessage, remaining);
  }
}
